// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"516":"d0e1fa2335f6161f","531":"70afec029592ba74"}[chunkId] + ".js";
};